/**
 * 符号付きパーセント表示ヘルパー。
 * - null / undefined / '' → '-'
 * - 数値変換できない → '-'
 * - 0 以上 → '+N.NN%'
 * - 負値 → '-N.NN%'
 *
 * 表示専用のため big.js は使わず Number ベース。金融計算は呼出元（バックエンド）で big.js 済み、
 * フロントは確定値（文字列）を受け取って表示するだけなので、ここで浮動小数点誤差は問題にならない。
 */
export const formatSignedPercent = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) {
    return '-';
  }
  const fixed = num.toFixed(2);
  if (num >= 0) {
    return `+${fixed}%`;
  }
  return `${fixed}%`;
};

export default formatSignedPercent;
